/**
 * Textos (`ca`) de la reimpressió d'etiquetes de lot (OBR-178): namespaces `backoffice.lotLabelReprint` (diàleg i historial del
 * BackOffice) i `planta.stockLabels` (pantalla d'Existències de l'App). Tall propi: no es toca `ca.ts`. Les tres llengües han de
 * tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes. Vocabulari: «Existències», mai «Stock».
 */

export const reprintCa = {
  'backoffice.lotLabelReprint': {
    // ── Acció i diàleg ────────────────────────────────────────────────────────────────
    action: 'Reimprimeix l’etiqueta',
    actionNoLot: 'Sense lot: no es pot etiquetar',
    dialogTitle: 'Reimprimeix l’etiqueta del lot',
    dialogBody:
      'Es genera un PDF amb el mateix lot, la mateixa caducitat i el mateix QR de l’etiqueta original. No canvia les existències ni crea cap lot nou: només en queda constància (qui, quan, quantes còpies i per què).',
    noLot:
      'Aquestes existències no tenen lot, així que no es poden etiquetar. Per donar-los un lot, regularitza-les des d’«A regularitzar».',
    fieldArticle: 'Article',
    fieldLot: 'Lot',
    fieldExpiry: 'Caducitat',
    fieldPlace: 'Lloc',
    fieldQuantity: 'Existències',
    noPlace: 'Sense lloc',
    noExpiry: 'Sense caducitat',
    copiesLabel: 'Còpies',
    copiesHint: 'D’1 a 99 còpies.',
    copiesInvalid: 'Indica un nombre de còpies entre 1 i 99.',
    reasonLabel: 'Motiu',
    reasonPlaceholder: 'Tria un motiu',
    reasonRequired: 'Tria per què la reimprimeixes.',
    reason_not_labelled: 'No es va etiquetar',
    reason_damaged: 'Etiqueta malmesa',
    reason_other: 'Altres',
    noteLabel: 'Nota',
    noteOptionalHint: 'Opcional.',
    noteRequiredHint: 'Obligatòria quan el motiu és «Altres».',
    noteRequired: 'Escriu el motiu de la reimpressió.',
    submit: 'Registra i genera el PDF',
    submitting: 'Generant…',
    retryRecord: 'Torna a registrar',
    retryDownload: 'Torna a baixar el PDF',
    downloadAgain: 'Baixa el PDF un altre cop',
    close: 'Tanca',
    cancel: 'Cancel·la',

    // ── Resultat ──────────────────────────────────────────────────────────────────────
    doneTitle: 'Etiqueta reimpresa',
    doneBody_one: 'S’ha registrat la reimpressió i s’ha baixat el PDF amb {{count}} còpia.',
    doneBody_other: 'S’ha registrat la reimpressió i s’ha baixat el PDF amb {{count}} còpies.',
    errPdf:
      'No s’ha pogut generar el PDF de l’etiqueta. No s’ha registrat res ni s’ha baixat cap etiqueta: torna-ho a provar.',
    errRecordAfterPdf:
      'El PDF està fet, però NO s’ha pogut registrar la reimpressió, i per això no s’ha baixat cap etiqueta. Torna-ho a provar: es registrarà una sola vegada.',
    errDownload:
      'La reimpressió s’ha registrat, però el navegador no ha pogut baixar el PDF. Torna-ho a provar: no es tornarà a registrar.',

    // ── Historial del lot ─────────────────────────────────────────────────────────────
    historyTitle: 'Reimpressions d’aquest lot',
    historyShow: 'Mostra les reimpressions',
    historyHide: 'Amaga les reimpressions',
    historyLoading: 'Carregant les reimpressions…',
    historyEmpty: 'Aquest lot no s’ha reimprès mai.',
    historyError: 'No s’ha pogut carregar l’historial de reimpressions.',
    historyRetry: 'Torna-ho a provar',
    historyCopies_one: '{{count}} còpia',
    historyCopies_other: '{{count}} còpies',
    historyBy: 'Per {{name}}',
    historyByUnknown: 'Per una persona de l’obrador',
    historyExpiry: 'Caducitat a l’etiqueta: {{date}}',
    historyNoExpiry: 'Sense caducitat a l’etiqueta',
    historyOrigin_backoffice: 'Des del BackOffice',
    historyOrigin_app: 'Des de l’App',
    historyPlace: 'Lloc: {{place}}',
    historyNoPlace: 'Sense lloc',
    historyMore: 'Es mostren les {{count}} reimpressions més recents.',

    errQr:
      'No s’ha pogut generar el codi QR de l’etiqueta, i una reimpressió no es fa sense el mateix QR. No s’ha registrat res ni s’ha baixat cap etiqueta: torna-ho a provar.',
    errQrNoRoom:
      'El format d’etiqueta no té lloc per al QR (massa text per a la mida de l’etiqueta). No s’ha registrat res ni s’ha baixat cap etiqueta: revisa el format a Configuració.',
    noticeExpiryChanged:
      'La caducitat del lot ha canviat des que es va carregar la pantalla: l’etiqueta porta la vigent ({{date}}).',
    noticeExpiryRemoved:
      'El lot ja no té caducitat des que es va carregar la pantalla: l’etiqueta no en porta.',
    formatLoading: 'Carregant el format d’etiqueta…',
    formatWarning:
      'No s’ha pogut carregar el format d’etiqueta de Configuració: la reimpressió es farà amb el format senzill.',
    formatNone:
      'Configuració no té cap format de «lot intern»: la reimpressió es farà amb el format senzill.',
    logoWarning: 'No s’ha pogut carregar el logotip de l’obrador: l’etiqueta sortirà sense logotip.',
    historyLotExpiryWas: 'el lot tenia {{date}}',
    historyLotNoExpiryWas: 'el lot no tenia caducitat',

    // ── Errors de l'RPC (mai crus) ────────────────────────────────────────────────────
    errForbidden: 'No tens permís per registrar reimpressions en aquest obrador.',
    errNoteTooLong: 'La nota és massa llarga: 500 caràcters com a màxim.',
    errBadCopies: 'El nombre de còpies ha de ser entre 1 i 99.',
    errBadReason: 'Tria el motiu de la reimpressió.',
    errNoteRequired: 'Quan el motiu és «Altres» cal escriure una nota.',
    errLotRequired: 'Aquestes existències no tenen lot: no es poden etiquetar.',
    errUnknownLot: 'No trobem aquest lot a l’obrador. Torna a carregar Existències.',
    errBadPlace: 'El lloc d’aquestes existències ja no és d’aquest obrador. Torna a carregar Existències.',
    errGeneric: 'No s’ha pogut registrar la reimpressió. Torna-ho a provar.',
  },

  'planta.stockLabels': {
    // ── Entrada (portada de Recepció) i pantalla ──────────────────────────────────────
    open: 'Reimprimeix l’etiqueta d’un lot',
    title: 'Existències',
    subtitle: 'Cerca un lot per reimprimir-ne l’etiqueta.',
    searchLabel: 'Cerca un lot',
    searchPlaceholder: 'Article, lot o ubicació',
    searchClear: 'Esborra la cerca',
    emptyNoData: 'Encara no hi ha lots a l’aparell. Connecta’l a la xarxa perquè s’hi baixin.',
    emptyNoMatch: 'Cap lot coincideix amb «{{query}}».',
    emptyWeb: 'Aquesta pantalla només funciona a l’App de planta, no a la versió web.',
    resultsCount_one: '{{count}} lot',
    resultsCount_other: '{{count}} lots',
    resultsLimited: 'Es mostren els primers {{count}}. Afina la cerca per veure’n més.',
    truncated:
      'La llista es limita als {{count}} primers lots. Afina la cerca o consulta Existències al BackOffice.',

    refresh: 'Actualitza la llista',
    refreshing: 'Actualitzant la llista…',
    refreshFailed:
      'No s’ha pogut actualitzar la llista. Es mostra l’última còpia que hi havia a l’aparell.',
    refreshOffline: 'Sense connexió: es mostra l’última còpia que hi havia a l’aparell.',

    // ── Un lot (línia lot + lloc) ─────────────────────────────────────────────────────
    lotLine: 'Lot {{lot}}',
    expiresOn: 'Caduca {{date}}',
    noExpiry: 'Sense caducitat',
    placeLine: 'Lloc: {{place}}',
    noPlace: 'Sense lloc',
    quantityLine: 'Existències: {{quantity}}',
    chooseLot: 'Reimprimeix',

    // ── Reimprimir ────────────────────────────────────────────────────────────────────
    printTitle: 'Reimprimeix l’etiqueta',
    reasonTitle: 'Per què la reimprimeixes?',
    reason_not_labelled: 'No es va etiquetar',
    reason_damaged: 'Etiqueta malmesa',
    reason_other: 'Altres',
    reasonRequired: 'Tria un motiu per poder imprimir.',
    noteLabel: 'Explica el motiu',
    notePlaceholder: 'Escriu-ho aquí',
    noteRequired: 'Escriu el motiu per poder imprimir.',
    printCopies_one: 'Imprimeix {{count}} etiqueta',
    printCopies_other: 'Imprimeix {{count}} etiquetes',
    printing: 'Imprimint…',
    back: 'Enrere',
    printedTo:
      'Etiqueta enviada a {{printer}}. La reimpressió queda registrada: si no hi ha connexió, s’enviarà en recuperar-la.',
    printedNotRecorded:
      'Etiqueta enviada a {{printer}}, però no s’ha pogut desar el registre de la reimpressió en aquest aparell. Avisa un responsable.',
    printLeftTitle: 'No s’ha imprès res, així que no s’ha registrat res.',
  },
} as const;
